import React from "react";
import { Field, FieldProps, ErrorMessage } from "formik";
import { formErrorMessage } from "./FormErrorMessage";
import CustomSelect from "../form/CustomSelect";

interface FormikSelectProps {
  name: string;
  options: string[] | { label: string; value: number | string }[];
  placeholder?: string;
  className?: string;
  isShowError?: boolean;
  onChange?: (value: string | { label: string; value: string | number }) => void;
  style?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  value?: any;
  searchable?: boolean; // ✅ new
  disabled?: boolean;
}

const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  options,
  placeholder,
  className,
  onChange,
  style,
  isShowError = false,
  buttonStyle,
  value,
  searchable = false,
  disabled = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const error = form.touched[name] && form.errors[name];

        return (
          <div className={`${className} z-index-100`}>
            <CustomSelect
              buttonStyle={buttonStyle}
              style={style}
              options={options}
              value={value ? value : field?.value}
              searchable={searchable} // ✅ pass down
              onChange={
                onChange
                  ? (val) => {
                      if (typeof val === "string") {
                        onChange(val);
                      } else if (val && typeof val.value !== "undefined") {
                        onChange({ label: val.label ?? "", value: val.value ?? "" });
                      } else {
                        onChange("");
                      }
                    }
                  : (val) =>
                      form.setFieldValue(
                        name,
                        typeof val === "string" ? val : val?.value ?? ""
                      )
              }
              placeholder={placeholder}
              error={error ? String(error) : ""}
              disabled={disabled}
            />

            {form.submitCount > 0 && !isShowError && (
              <ErrorMessage name={name} render={formErrorMessage} />
            )}
          </div>
        );
      }}
    </Field>
  );
};

export default FormikSelect;
